import { PaginatedResponse } from "../../types/dto/program";

/** El API limita `$limit` a 200 registros por página (`paginate.max`). */
export const FEATHERS_MAX_PAGE_SIZE = 200;

export function extractPaginatedData<T extends object>(
  result: PaginatedResponse<T> | T[] | null | undefined
): T[] {
  if (Array.isArray(result)) return result;
  return result?.data ?? [];
}

export function extractPaginatedTotal<T extends object>(
  result: PaginatedResponse<T> | T[] | null | undefined,
  dataLength: number
): number {
  if (Array.isArray(result)) return dataLength;
  return result?.total ?? dataLength;
}

export async function fetchAllPaginated<T extends object>(
  find: (query: Record<string, unknown>) => Promise<PaginatedResponse<T> | T[]>,
  baseQuery: Record<string, unknown>,
  pageSize = FEATHERS_MAX_PAGE_SIZE
): Promise<T[]> {
  const all: T[] = [];
  let skip = 0;
  let total = Infinity;

  while (skip < total) {
    const result = await find({
      ...baseQuery,
      $limit: pageSize,
      $skip: skip,
    });

    const data = extractPaginatedData(result);
    total = extractPaginatedTotal(result, data.length);

    if (!data.length) break;

    all.push(...data);
    skip += data.length;

    if (data.length < pageSize) break;
  }

  return all;
}
